import { Component, OnInit, Input, OnChanges, SimpleChange } from '@angular/core';
import { CurrentUserStateService } from '../../../shared/services/current-user-state.service';

@Component({
    selector: 'side-nav-bar',
    templateUrl: './side-nav-bar.component.html',
    styleUrls: ['./side-nav-bar.component.scss'],
})
export class SideNavBarComponent implements OnInit, OnChanges {
    @Input() sideNavWidth: number;
    navWidth = 56;
    showMobileMenu = false;
    showProductMenu = false;
    isExpaned = false;

    constructor(private currentUserStateService: CurrentUserStateService) {}

    ngOnInit() {
        this.openCloseMobileMenu();
    }

    openCloseMobileMenu() {
        let mobileMenu = document.getElementById('menu-mobile');

        if (mobileMenu) {
            this.showMobileMenu = !this.showMobileMenu;
            mobileMenu.style.width = '0px';
            if (this.showMobileMenu) {
                mobileMenu.style.width = '270px';
            }
        }
    }

    ngOnChanges(changes: { [property: string]: SimpleChange }) {
        let change: SimpleChange = changes['sideNavWidth'];
        if (change && change.currentValue) {
            this.navWidth = change.currentValue;
            this.isExpaned = this.navWidth > 56 ? true : false;
            this.openCloseMobileMenu();
        }
    }

    toggleMobileMenu() {}

    get showNav() {
        return this.currentUserStateService.isLoggedIn();
    }

    isUserLoggedIn() {
        return this.currentUserStateService.isLoggedIn();
    }

    hasItemClicked(val: boolean) {
        this.openCloseMobileMenu();
    }

    mouseEnter(section: any) {
        this.showProductMenu = true;
    }

    mouseLeave(section: any) {
        setTimeout(() => {
            this.showProductMenu = false;
        }, 500);
    }
}
